/**
 * @generated SignedSource<<fc088668b7dcc30256161ba820ce6b89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ScormFileStatus = "failed" | "processing" | "ready" | "%future added value";
export type EditorScormEmbedQuery$variables = {
  scormFileId: string;
};
export type EditorScormEmbedQuery$data = {
  readonly node: {
    readonly __typename: "ScormFile";
    readonly failedErrorMessage: string | null;
    readonly id: string;
    readonly indexFileKey: string | null;
    readonly status: ScormFileStatus;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type EditorScormEmbedQuery = {
  response: EditorScormEmbedQuery$data;
  variables: EditorScormEmbedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scormFileId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "scormFileId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "indexFileKey",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "failedErrorMessage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditorScormEmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "type": "ScormFile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorScormEmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "type": "ScormFile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d7f2b33249bc233ac54ab536dc53d6af",
    "id": null,
    "metadata": {},
    "name": "EditorScormEmbedQuery",
    "operationKind": "query",
    "text": "query EditorScormEmbedQuery(\n  $scormFileId: ID!\n) {\n  node(id: $scormFileId) {\n    __typename\n    ... on ScormFile {\n      __typename\n      id\n      status\n      indexFileKey\n      failedErrorMessage\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8f26c53b5c54996a3c74653d4a87e360";

export default node;
